// dom
// starting from 10 since core/constants is 0-10
export const PrimitiveTreeStep = 10 as const;
export const NativeTreeStep = 11 as const;
export const ComponentTreeStep = 12 as const;
export const WireTreeStep = 13 as const;

export const NATIVE = 15 as const;
export const COMPONENT = 16 as const;
export const PRIMITIVE = 17 as const;
